module.exports = __webpack_public_path__ + "img/81000.0670bc1c.jpg";